export const calculateScores = (answers) => {
  const scores = {
    christian: (answers.q1 || 1) + (answers.q2 || 1) + (answers.q3 || 1),
    creator: (answers.q4 || 1) + (answers.q5 || 1) + (answers.q6 || 1),
    caretaker: (answers.q7 || 1) + (answers.q8 || 1) + (answers.q9 || 1),
    connector: (answers.q10 || 1) + (answers.q11 || 1) + (answers.q12 || 1),
  };

  const getTier = (score) => {
    if (score >= 10) return 'Thriving';
    if (score >= 7) return 'Growing';
    if (score >= 4) return 'Stalling';
    return 'Stuck';
  };

  const tiers = {
    christian: getTier(scores.christian),
    creator: getTier(scores.creator),
    caretaker: getTier(scores.caretaker),
    connector: getTier(scores.connector),
  };

  const personas = ['christian', 'creator', 'caretaker', 'connector'];
  
  let strongest = personas[0];
  let weakest = personas[0];

  personas.forEach(p => {
    if (scores[p] > scores[strongest]) strongest = p;
    if (scores[p] < scores[weakest]) weakest = p;
  });

  return { scores, tiers, strongest, weakest };
};